import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Hero from '../../components/ui/Hero';
import { blogPosts } from '../../utils/blogPosts';

const BlogPage = () => {
  return (
    <div>
      <Hero
        title="Animatronic Blog"
        description="News, stories, and insights from the world of animatronics"
        compact
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid gap-8">
          {blogPosts.map(post => (
            <motion.article
              key={post.slug}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-background-secondary rounded-lg overflow-hidden border border-gray-800 hover:border-brand/50 transition-all"
            >
              <Link to={`/community/blog/${post.slug}`}>
                {post.coverImage && (
                  <img
                    src={post.coverImage}
                    alt={post.title}
                    className="w-full h-48 object-cover"
                  />
                )}
                <div className="p-6">
                  <h2 className="text-2xl font-bold mb-2 text-content-primary">
                    {post.title}
                  </h2>
                  <p className="text-content-secondary mb-4">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-sm text-content-secondary">
                    <div className="flex items-center gap-4">
                      <span>{post.author}</span>
                      <time>{new Date(post.date).toLocaleDateString()}</time>
                    </div>
                    {post.tags.length > 0 && (
                      <div className="flex items-center gap-2">
                        {post.tags.slice(0, 2).map(tag => (
                          <span
                            key={tag}
                            className="px-2 py-1 bg-background rounded-full text-xs"
                          >
                            {tag}
                          </span>
                        ))}
                        {post.tags.length > 2 && (
                          <span className="text-xs">+{post.tags.length - 2}</span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;